import { useEffect, useState } from 'react'

import { F0Box, F0Card, F0Dialog } from '@factorialco/f0-react'
import { TrainingDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ScormPackageUpload from 'modules/trainings/components/ScormPackage/ScormPackageUpload'

type Step = 'choice' | 'scorm-upload'

interface ContentTypeDialogProps {
  isOpen: boolean
  onClose: () => void
  onNavigateToBuilder: () => void
  trainingId: number
  companyId: number
  scormPackage: TrainingDetailFragment['scormPackage']
}

const ContentTypeDialog = ({
  isOpen,
  onClose,
  onNavigateToBuilder,
  trainingId,
  companyId,
  scormPackage,
}: ContentTypeDialogProps) => {
  const [step, setStep] = useState<Step>('choice')

  useEffect(() => {
    if (isOpen) setStep('choice')
  }, [isOpen])

  const handleClose = () => {
    onClose()
  }

  const handleNativeContentClick = () => {
    handleClose()
    onNavigateToBuilder()
  }

  const handleScormClick = () => {
    setStep('scorm-upload')
  }

  const title =
    step === 'choice'
      ? i18n.t('trainings.content_type_dialog.title')
      : i18n.t('trainings.content_type_dialog.scorm_title')

  return (
    <F0Dialog isOpen={isOpen} onClose={handleClose} title={title}>
      {step === 'choice' && (
        <F0Box display="flex" flexDirection="column" gap="md">
          <F0Card
            compact
            title={i18n.t('trainings.content_type_dialog.native_title')}
            description={i18n.t('trainings.content_type_dialog.native_description')}
            onClick={handleNativeContentClick}
          />
          <F0Card
            compact
            title={i18n.t('trainings.content_type_dialog.scorm_title')}
            description={i18n.t('trainings.content_type_dialog.scorm_description')}
            onClick={handleScormClick}
          />
        </F0Box>
      )}
      {step === 'scorm-upload' && (
        <ScormPackageUpload
          trainingId={trainingId}
          companyId={companyId}
          scormPackage={scormPackage}
          onUploadSuccess={handleClose}
        />
      )}
    </F0Dialog>
  )
}

export default ContentTypeDialog
